import React from 'react';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import BaseDialog from './BaseDialog';

interface ConfirmProps {
  header?: string;
  message: string;
  open: boolean;
  confirmString?: string;
  cancelString?: string;
  onCancel(): void;
  onConfirm(): void;

}

const ConfirmDialog = ({ message, header, open, onCancel, onConfirm, confirmString, cancelString }: ConfirmProps) => {
  const content = <Box
    sx={{
      minHeight: 150,
      display: "flex",
      alignItems: "center"
    }}>
    <Box sx={{
      width: "100%"
    }}>
      <DialogContentText>{message}</DialogContentText>
      <DialogActions>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {confirmString ? confirmString : 'Confirm' }
      </Button>
        <Button onClick={onCancel} variant="contained" color="secondary">
          { cancelString ? cancelString : 'Cancel' }
      </Button>
      </DialogActions>
    </Box>

  </Box>;



  return (
    <BaseDialog
      header={header}
      open={open}
      showCloseIcon={true}
      showCloseButton={false}
      onClose={onCancel}>
        {content}
    </BaseDialog>
  );
};

export default ConfirmDialog;